import CardManagement from 'shared-assets/components/PaymentSolutions/CardManagement/CardManagementThemed';

angular
    .module('kareo.ui.shared.directives.tebra-payment-cards-on-file', [
        'react'
    ])
    .directive('tebraPaymentCardsOnFile', dcTebraPaymentCardsOnFile);

dcTebraPaymentCardsOnFile.$inject = ['reactDirective'];

function dcTebraPaymentCardsOnFile(reactDirective) {
    const bindings = {
        cards: '=',
        autoDefaultError: '=',
        config: '=',
        onAddCardCancelled: '=',
        onCardAdded: '=',
        onDeleteCard: '=',
        onUpdateCard: '=',
        patientAddress: '=',
        patientId: '=',
    };

    return reactDirective(CardManagement, bindings, props => {
        return props;
    });
}
